import CustomFilterText from "../unit/CustomFilterText";
import FilterAgency from "../unit/FilterAgency";
import FilterDateLastYear from "../unit/FilterDateLastYear";
import FilterDecision from "../unit/FilterDecision";
import FilterProduct from "../unit/FilterProduct";

const counselorsApplicationsFilters = [
  // <CustomFilterText
  //   label="Referral"
  //   source="counselor_agency"
  //   defaultValue=""
  //   alwaysOn
  // />,
  <FilterAgency
    label="Referral Source"
    source="counselor_agency"
    defaultValue=""
    alwaysOn
  />,
  // <CustomFilterText
  //   label="Counselor Name"
  //   source="counselor_name"
  //   defaultValue=""
  //   alwaysOn
  // />,
  <CustomFilterText label="App #" source="iId" defaultValue="" />,
  <CustomFilterText label="Loan #" source="sLoanNum" defaultValue="" />,
  <CustomFilterText label="User #" source="iUserId" defaultValue="" />,
  <FilterDateLastYear
    label="Application Submitted"
    source="application_submitted"
    before="and"
    variant="outlined"
  />,
  <FilterProduct label="Product" source="sProductName" before="and" />,
  <FilterDecision label="Decision" source="sReview" before="and" />,
  // <CustomFilterText
  //   label="Counselor Agency"
  //   source="counselor_agency"
  //   defaultValue=""
  // />,
];

export default counselorsApplicationsFilters;
